import PropTypes from 'prop-types'
import React, { useState } from 'react'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import BootstrapTable from 'react-bootstrap-table-next'
// import cellEditFactory, { Type } from 'react-bootstrap-table2-editor'
import { keys } from 'lodash'
import { Form } from 'react-bootstrap'

const GET_ITEM_PERMISSIONS = gql`
  query GetItemPermissions($id: ID!) {
    itemPermissions(id: $id) {
      read {
        acl
        inherited
        inheritsFromId
      }
      write {
        acl
        inherited
        inheritsFromId
        inheritsFrom {
          parentId
        }
      }
      parentId
    }
  }
`

export default function ItemPermissions({ id }) {
  // eslint-disable-next-line
  const { loading, error, data } = useQuery(GET_ITEM_PERMISSIONS, {
    variables: {
      id: id
    },
    fetchPolicy: 'cache-and-network'
  })

  const readAcl = ((data || {}).itemPermissions || {}).read || { acl: [] }
  const writeAcl = ((data || {}).itemPermissions || {}).write || { acl: [] }

  const combinedAcl = useCombinedAcl(readAcl, writeAcl)

  const inheritedStyle = {
    fontWeight: 'lighter',
    fontStyle: 'italic'
  }

  const columns = [
    {
      dataField: 'subject',
      text: 'User or Role',
      editable: false,
      formatter: (cell, row) => {
        return (
          <p>{row.subject} {row.inherited ? <span style={inheritedStyle}>INHERITED</span> : ''}</p>
        )
      }
    },
    {
      dataField: 'read',
      text: 'Readable',
      // editor: {
      //   type: Type.CHECKBOX
      // }
    },
    {
      dataField: 'write',
      text: 'Writable',
      // editor: {
      //   type: Type.CHECKBOX
      // }
    },
  ]

  const rowStyle = (row, rowIndex) => {
    if (row.inherited) {
      return {
        background: '#cccccc'
      }
    }
  }

  return (
    <>
      <div className="manage-permissions-wrapper">
        {/*<ItemPermissionsInheritance readAcl={readAcl} writeAcl={writeAcl} />*/}
        <div className="manage-permissions-heading">
          <div className="file-metadata-heading">
            To grant a user permissions, enter their email and select permissions. Users with write permissions will automatically be granted read.
          </div>
        </div>
        {data ?
          <BootstrapTable
            responsive
            wrapperClasses="table-responsive"
            keyField='name'
            // data={combinedAcl}
            columns={columns}
            noDataIndication="Fetching Permissions..."
            bordered={false}
            rowStyle={rowStyle}
            {...combinedAcl }
            // cellEdit={ cellEditFactory({ mode: 'click' }) }
            // selectRow={selectRow}
            // hover
            // pagination={paginationFactory(paginationOptions)}
            // remote={{
            //   filter: true,
            //   pagination: true,
            //   sort: true,
            //   cellEdit: false,
            // }}
            // onTableChange={this.onTableChange}
          />
          :
          ''
        }
      </div>
    </>
  )
}

function mergeAcls(readAcl, writeAcl) {
  let merged = {}

  readAcl.acl.forEach((subject) => {
    merged[subject] = { read: true, write: false, inherited: readAcl.inherited }
  })

  writeAcl.acl.forEach((subject) => {
    merged[subject] = { read: true, write: true, inherited: writeAcl.inherited }
  })

  return keys(merged).map((subject) => {
    return {
      subject: subject,
      ...merged[subject]
    }
  })
}

function useCombinedAcl(readAcl, writeAcl) {
  // eslint-disable-next-line
  const [columns, setColumns] = useState(() => {
    const initialState = mergeAcls(readAcl, writeAcl)
    return initialState
  })

  function handleTableChange(type, newState) {
    console.log('table changed: ', type)
    console.dir(newState)
  }

  return {
    onTableChange: handleTableChange,
    data: columns
  }
}


ItemPermissions.propTypes = {
  id: PropTypes.string
}

function ItemPermissionsInheritance({readAcl, writeAcl}) {
  const readInherited = useInheritedAcl(readAcl.inherited)
  const writeInherited = useInheritedAcl(writeAcl.inherited)

  return (
    <>
      <Form.Check
        type='checkbox'
        label='Inherit Read Permissions'
        {...readInherited }
      />
      <Form.Check
        type='checkbox'
        label='Inherit Write Permissions'
        { ...writeInherited }
      />
    </>
  )
}

function useInheritedAcl(initialValue) {
  const [inherited, setInherited] = useState(initialValue)

  function handleChange(e) {
    setInherited(e.target.checked)
  }

  return {
    checked: inherited,
    onChange: handleChange
  }
}

ItemPermissionsInheritance.propTypes = {
  writeAcl: PropTypes.shape({
    acl: PropTypes.arrayOf(PropTypes.string),
    inherited: PropTypes.bool,
    inheritsFromId: PropTypes.string
  }),
  readAcl: PropTypes.shape({
    acl: PropTypes.arrayOf(PropTypes.string),
    inherited: PropTypes.bool,
    inheritsFromId: PropTypes.string
  })
}
